import React from "react";

export default function MatchRoundHeader({ title }) {
  return (
    <div className="flex items-center gap-1 bg-[var(--theme-bg)] rounded-lg p-2 cursor-pointer text-sm font-medium">
      {title}
    </div>
  );
}
